import React from 'react';
import './styles.scss';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useTranslation } from 'react-i18next';

function ExecutionProgress({ completed, totalTime, initialMonths, initialDate, pendingMonths, endingDate }) {
    const { t } = useTranslation();

    return (
        <div className='c-progress-bar'>
            <h3 id='report-total-time-title' className='c-total-time-title'>{`${t('one_pager_report.total_time')} ${totalTime} ${t('months')}`}</h3>
            <div className='c-linear_porcent-data'>
                <div className='content-data report-content-data'>
                    <p className='elapsed-time-text'>{t('temporary_advance_completed_label')}</p>
                </div>

                <div className='content-data report-content-data'>
                    <p className='pending-time-text'>{t('pending')}</p>
                </div>
            </div>

            <LinearProgress
                className='linear-chart'
                variant="determinate"
                value={Math.max(0, Math.min(completed, 100))}
                style={{ width: '100%' }} />

            <div className='c-linear_porcent-data'>
                <div className='initial-content-data'>
                    <p className='initial-months'>{`${initialMonths} ${t('months')}`}</p>
                    <div className='initial-time'>
                        <p className="initial-date">
                            <b>{initialDate}</b>
                        </p>
                        <p className='initial-detail-text'>
                            {t('temporary_advance_completed_two')}
                        </p>
                    </div>
                </div>

                <div className='pending-content-data'>
                    <p className='pending-months'>{`${Math.abs(pendingMonths)} ${t('months')}`}</p>
                    <div className='pending-time'>
                        <p className="pending-date">
                            <b>{endingDate}</b>
                        </p>
                        <p className='pending-detail-text'>
                            {t('temporary_advance_pending_two')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ExecutionProgress;